import gql from 'graphql-tag';

const GET_ORDERS_COUNTERS = gql`
    query getOrdersCounters ($filters: OrdersCountersInput) {
        getOrdersCounters (filters: $filters) {
            message,
            status,
            data {
                totals {
                    name,
                    resume {
                        pendientePicking,
                        inPicking,
                        pendienteAuditoria,
                        pendienteFacturacion,
                        errorFacturar,
                        facturado,
                        anulado,
                        total
                    },
                    despachoExpress {
                        pendientePicking,
                        inPicking,
                        pendienteAuditoria,
                        pendienteFacturacion,
                        errorFacturar,
                        facturado,
                        anulado,
                        total
                    },
                    retiroEnTienda {
                        pendientePicking,
                        inPicking,
                        pendienteAuditoria,
                        pendienteFacturacion,
                        errorFacturar,
                        facturado,
                        anulado,
                        total
                    },
                    despachoDomicilio {
                        pendientePicking,
                        inPicking,
                        pendienteAuditoria,
                        pendienteFacturacion,
                        errorFacturar,
                        facturado,
                        anulado,
                        total
                    },
                    despachoDinamico {
                        pendientePicking,
                        inPicking,
                        pendienteAuditoria,
                        pendienteFacturacion,
                        errorFacturar,
                        facturado,
                        anulado,
                        total
                    },
                    clickAlAuto {
                        pendientePicking,
                        inPicking,
                        pendienteAuditoria,
                        pendienteFacturacion,
                        errorFacturar,
                        facturado,
                        anulado,
                        total
                    }
                },
                bySalesChannel {
                    name,
                    id,
                    resume {
                        pendientePicking,
                        inPicking,
                        pendienteAuditoria,
                        pendienteFacturacion,
                        errorFacturar,
                        facturado,
                        anulado,
                        total
                    },
                    despachoExpress {
                        pendientePicking,
                        inPicking,
                        pendienteAuditoria,
                        pendienteFacturacion,
                        errorFacturar,
                        facturado,
                        anulado,
                        total
                    },
                    despachoDomicilio {
                        pendientePicking,
                        inPicking,
                        pendienteAuditoria,
                        pendienteFacturacion,
                        errorFacturar,
                        facturado,
                        anulado,
                        total
                    },
                    despachoDinamico {
                        pendientePicking,
                        inPicking,
                        pendienteAuditoria,
                        pendienteFacturacion,
                        errorFacturar,
                        facturado,
                        anulado,
                        total
                    },
                    clickAlAuto {
                        pendientePicking,
                        inPicking,
                        pendienteAuditoria,
                        pendienteFacturacion,
                        errorFacturar,
                        facturado,
                        anulado,
                        total
                    },
                    retiroEnTienda {
                        pendientePicking,
                        inPicking,
                        pendienteAuditoria,
                        pendienteFacturacion,
                        errorFacturar,
                        facturado,
                        anulado,
                        total
                    }
                }
            }
        }
    }
`;

export default GET_ORDERS_COUNTERS;
